import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Brands() {
    const { t } = useTranslation();

    return (
        <>
            <section className="landingPages bg-gray-100 py-16">
                <div className="container mx-auto h-full flex items-center justify-between px-4">
                    <div className="w-full md:w-[48%] flex flex-col">
                        <div className="text-[40px] md:text-[50px] font-bold capitalize text-[#b58630]">
                            {t("Brands")}
                        </div>
                        <div className="font-bold text-[18px] md:text-[20px] capitalize flex items-center gap-[7px] mt-2">
                            <Link to={"/"} className="hover:text-[#b58630] transition-colors">
                                {t("home")}
                            </Link>{" "}
                            - <div className="text-[#b58630]">{t("Brands")}</div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="relative py-[40px] bg-white">
                <div className="container mx-auto px-4">
                    <div className="text-center mb-12">
                        <h2 className="text-[30px] md:text-[40px] font-bold text-[#b58630] capitalize">
                            {t("Discover OMA Sunglasses")}
                        </h2>
                        <p className="text-[16px] md:text-[18px] text-gray-600 mt-4 max-w-2xl mx-auto">
                            {t(
                                "Experience the pinnacle of eyewear innovation with OMA's Clear+ Polarized™ technology, crafted in Japan's finest factories."
                            )}
                        </p>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
                        <div className="flex flex-col justify-center">
                            <h3 className="text-[24px] font-semibold text-[#b58630] mb-4">
                                {t("Clear+ Polarized™ Technology")}
                            </h3>
                            <p className="text-gray-700 mb-4">
                                {t(
                                    "OMA sunglasses feature the 5th generation Clear+ Polarized™ lenses, an exclusive technology designed to elevate your visual experience. Engineered in Japan, these lenses offer:"
                                )}
                            </p>
                            <ul className="list-disc list-inside text-gray-700 space-y-2">
                                <li>{t("Crystal-clear vision in all lighting conditions")}</li>
                                <li>{t("Superior protection from UV rays")}</li>
                                <li>{t("Reduced glare and reflections for enhanced comfort")}</li>
                                <li>{t("Vivid colors and improved contrast")}</li>
                            </ul>
                            <p className="text-gray-700 mt-4 italic">
                                {t(
                                    "Not just lenses, but a masterpiece of Japanese craftsmanship, blending comfort, luxury, and exceptional performance."
                                )}
                            </p>
                            <p className="text-[#b58630] font-bold mt-4">
                                {t("Clear+ Polarized™ by OMA — Clarity, Comfort, Class.")}
                            </p>
                        </div>
                        <div className="flex justify-center items-center">
                            <img
                                src={require("../../assets/image/1.jpg")}
                                alt="OMA Sunglasses"
                                className="rounded-lg shadow-lg w-full h-[300px]"
                            />
                        </div>
                    </div>
                    <div className="text-center mb-12">
                        <h3 className="text-[24px] font-semibold text-[#b58630] mb-4">
                            {t("Explore OMA's Collection")}
                        </h3>
                        <p className="text-gray-600 max-w-2xl mx-auto">
                            {t(
                                "From sleek designs to cutting-edge technology, OMA sunglasses redefine style and functionality."
                            )}
                        </p>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                        {[
                            {
                                src: require("../../assets/image/1.jpg"),
                                alt: "OMA Model 1",
                                title: t("Classic Aviator"),
                            },
                            {
                                src: require("../../assets/image/2.jpg"),
                                alt: "OMA Model 2",
                                title: t("Modern Round"),
                            },
                            {
                                src: require("../../assets/image/3.jpg"),
                                alt: "OMA Model 3",
                                title: t("Sporty Wrap"),
                            },
                        ].map((item, index) => (
                            <div key={index} className="group">
                                <img
                                    src={item.src}
                                    alt={item.alt}
                                    className="w-full h-[200px] object-cover rounded-lg shadow-md group-hover:shadow-xl transition-shadow"
                                />
                                <p className="text-center text-[16px] font-medium text-gray-700 mt-2">
                                    {item.title}
                                </p>
                            </div>
                        ))}
                    </div>
                    <div className="text-center mt-12">
                        <Link
                            to="/collections"
                            className="inline-block bg-[#b58630] text-white py-3 px-6 rounded-lg font-semibold hover:bg-[#a57729] transition-colors"
                        >
                            {t("Shop OMA Collection")}
                        </Link>
                    </div>
                </div>
            </section>
        </>
    );
}